import { rectangle } from "@/math/coordinates";
import type { Board } from "@/model/board";
import type { BoardCard } from "@/model/card";
import type { RelativeCoordinate } from "@/model/coordinates";
import { relativeCoord } from "@/model/coordinates";
import { fixLine } from "@/model/shape";

export const borderLines = [
  fixLine("bv1", relativeCoord(0, 0), relativeCoord(0, 1), true),
  fixLine("bv2", relativeCoord(1, 0), relativeCoord(1, 1), true),
  fixLine("bh1", relativeCoord(0, 0), relativeCoord(1, 0), true),
  fixLine("bh2", relativeCoord(0, 1), relativeCoord(1, 1), true),
];

export class BoardLocation {
  id(): string {
    return "";
  }

  // eslint-disable-next-line @typescript-eslint/class-literal-property-style
  get name() {
    return "";
  }

  get bounds() {
    return rectangle({ from: relativeCoord(0, 0), to: relativeCoord(1, 1) });
  }

  // bounds without any background text
  get freeBounds() {
    return this.bounds;
  }

  get shapes() {
    return [...borderLines];
  }

  matches(_: RelativeCoordinate) {
    return true;
  }

  cards(board: Board) {
    const cards = new Array<BoardCard>();
    for (const id in board.cards) {
      if (this.matches(board.cards[id].meta.pos)) {
        cards.push(board.cards[id]);
      }
    }
    return cards;
  }
}
